import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-072524ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"color":"#333"} }
const _hoisted_2 = { style: {"color":"#333"} }

import {
  ref,
  reactive,
  withDefaults,
} from "vue";
import { 
  sealLicenseApplyApi,//印章证照刻制提交
  sealLicenseDetailApi,//印章证照刻制申请
 } from "@/api/businessChange";
import change from "@/composables/change"

export default /*#__PURE__*/_defineComponent({
  props: {
    BranchCompanyFlowId: { default: 0 },
    reEdit: { type: Boolean, default: false },
    update: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { BranchCompanyFlowId: number, reEdit:boolean, update: boolean }


const plainOptions = [
  "公章",
  "法人章",
  "合同章",
  "发票章",
  "财务章",
  "营业执照正本",
  "营业执照副本",
  // "法人身份证",
  // "股东身份证(Lisa)",
  // "集团公司章程",
];
let FormData = ref({
  Seals: [],
});

//封装方法字段
const FormRef = ref()
const common = reactive({
  ApplyApi:sealLicenseApplyApi,
  DetailApi:sealLicenseDetailApi,
  FormData:FormData,
  nodeIdx:8,
  FormRef:FormRef,
  props:reactive(props),
})

const {
  edit,
  winHeight,
} = change(common)


return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    style: _normalizeStyle({ minHeight: _unref(winHeight) + 'px' }),
    class: _normalizeClass(["bussiness-check-wrapper", !_unref(edit)? 'border-bottom mb24': '']),
    layout: "vertical",
    validateTrigger: "blur",
    model: _unref(FormData),
    ref_key: "FormRef",
    ref: FormRef
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form_item, {
        name: "Seals",
        label: "印章、证照刻制申请",
        rules: [{ required: true, message: '请勾选印章、证照刻制申请' }],
        style: {"margin-bottom":"14px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_checkbox_group, {
            value: _unref(FormData).Seals,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(FormData).Seals) = $event))
          }, {
            default: _withCtx(() => [
              (_unref(edit) || __props.BranchCompanyFlowId ==0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(plainOptions, (item, index) => {
                    return _createVNode(_component_a_checkbox, {
                      key: index,
                      value: (index + 1),
                      label: item
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_1, _toDisplayString(plainOptions[index]), 1)
                      ]),
                      _: 2
                    }, 1032, ["value", "label"])
                  }), 64))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(FormData).Seals, (item) => {
                    return (_openBlock(), _createBlock(_component_a_checkbox, {
                      key: item,
                      value: item,
                      label: plainOptions[item - 1],
                      disabled: true
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_2, _toDisplayString(plainOptions[item - 1]), 1)
                      ]),
                      _: 2
                    }, 1032, ["value", "label"]))
                  }), 128))
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["style", "class", "model"]))
}
}

})